module.exports = __webpack_public_path__ + "static/media/11NEPAD4.24bab791.jpg";